import React from "react";
import classnames from "classnames";

import { withShowIf } from "../with-show-if/with-show-If.component";

import { ErrorBoxProps } from "./error-box.props";
import { useErrorBoxStyles } from "./error-box.styles";
import { ErrorMessage } from "./error-message/error-message.component";

export const ErrorBox = withShowIf((props: ErrorBoxProps) => {
  const classes = useErrorBoxStyles();
  const { fullHeight = true } = props;

  const classNames = classnames({
    [classes.errorWrapper]: true,
    [classes.fullHeight]: fullHeight,
  });

  return (
    <div className={classNames}>
      <ErrorMessage message={props.message} title={props.title} />
    </div>
  );
});
